// terminal/src/components/FileExplorer/types.ts

/**
 * File entry from agent directory listing
 */
export interface FileEntry {
  name: string;
  entry_type: FileEntryType;
  size: number | null;
  modified: number | null;
  permissions: string | null;
  hidden: boolean;
  symlink: boolean;
  symlink_target: string | null;
}

export type FileEntryType = 'file' | 'directory' | 'symlink' | 'other';

export type SortBy = 'name' | 'size' | 'modified' | 'type';
export type SortOrder = 'ascending' | 'descending';

/**
 * File error from agent
 */
export type FileError =
  | { type: 'not_found' }
  | { type: 'permission_denied' }
  | { type: 'not_a_directory' }
  | { type: 'path_traversal' }
  | { type: 'outside_allowed_roots' }
  | { type: 'io_error'; message: string }
  | { type: 'invalid_path' };

/**
 * Context menu actions
 */
export type ContextAction =
  | 'copy-path'
  | 'copy-name'
  | 'edit-micro'
  | 'cat'
  | 'reveal'
  | 'cd';

/**
 * FileExplorer preferences stored in localStorage
 */
export interface FileExplorerPreferences {
  followCwd: boolean;
  showHidden: boolean;
  sortBy: SortBy;
  sortOrder: SortOrder;
  sidebarWidth: number;
  collapsed: boolean;
}

export const DEFAULT_PREFERENCES: FileExplorerPreferences = {
  followCwd: true,
  showHidden: false,
  sortBy: 'name',
  sortOrder: 'ascending',
  sidebarWidth: 250,
  collapsed: false,
};
